/* eslint-disable react-hooks/exhaustive-deps */
import Listado from 'components/public/Listado/Listado';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { titulosListadoAlumnosPorTaller } from 'utils/constants';
import { fetchInscriptosTaller } from 'utils/redux/features/inscriptosSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { fetchTallerPorId } from '../../../../utils/redux/features/tallerIdSlice';
import Spinner from 'components/public/Spinner/Spinner';
import { UsuarioAlumno } from 'utils/models/types';

const InscriptosTaller = () => {
  const navigate = useNavigate();
  const { inscriptos, loadingInscriptos, errorInscriptos } = useSelector((state: RootState) => state.inscriptos);
  const { taller, loadingTaller, errorTaller } = useSelector((state: RootState) => state.taller);
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();

  useEffect(() => {
    dispatch(fetchInscriptosTaller(Number(id)));
    dispatch(fetchTallerPorId(Number(id)));
  }, [dispatch]);

  const onAgregar = () => {
    navigate(`/admin/alta-usuario`);
  };

  const onEditar = (id: number) => {
    navigate(`/admin/usuarios/${id}`);
  };

  const onEliminar = (id: number) => {
    navigate(`/admin/usuarios/baja/${id}`);
  };

  const error401 = errorInscriptos?.includes('permisos') || errorTaller?.includes('permisos');

  const inscriptosListado: UsuarioAlumno[] = inscriptos.map((u: UsuarioAlumno) => {
    return {
      Id: u.Id,
      Activo: u.Activo ? 'Sí' : 'No',
      Nombre: `${u.Nombre} ${u.Apellido}`,
      Email: u.Email,
      Rol: u.Rol,
      FechaNac: u.FechaNac || 'No ingresada',
      DescuentoAsignado:
        typeof u.DescuentoAsignado === 'number' && u.DescuentoAsignado > 0 ? `${u.DescuentoAsignado}%` : '-',
      Telefono: u.Telefono || '-',
      EsElenco: u.EsElenco ? 'Sí' : 'No',
      TipoSocio: u.TipoSocio !== 'Nada' ? u.TipoSocio : '-',
      DetallePath: `/admin/usuarios/${u.Id}`,
    };
  });

  return loadingInscriptos || loadingTaller ? (
    <Spinner />
  ) : errorInscriptos || errorTaller ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={inscriptosListado}
      headCells={titulosListadoAlumnosPorTaller}
      titulo={`Inscriptos a ${taller.Nombre}`}
      onAgregar={onAgregar}
      onEditar={onEditar}
      onEliminar={onEliminar}
      loading={loadingInscriptos}
    />
  );
};

export default InscriptosTaller;
